export default {
    'loading': 'Loading',
    'trust': '【{name} entrust】',
    'SelectPlaceholder': 'Please Select',
};
